// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Signup__alert{position:fixed;top:10%;left:0;right:0;width:500px;margin:0 auto;text-align:center;background-color:#272727;color:#fff;padding:16px;box-shadow:0px 4px 6px 0px rgba(0,0,0,0.4)}.Signup__logo{margin:16px auto;width:200px;display:block}.Signup__title{font-weight:600;text-align:center;line-height:normal}.Signup__info{margin-top:12px;font-size:12px;font-weight:600;text-align:center}.Signup__error{margin-top:24px;padding:16px;width:100%;color:red;background-color:rgba(255,0,0,0.08);font-size:12px;line-height:normal;box-sizing:border-box}.Signup__forgot{margin:8px 0 24px;font-size:14px}.Signup__post-info{margin-top:16px;text-align:center}.Signup__reset-link{color:#1570ef;text-decoration:underline;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"alert": "Signup__alert",
	"logo": "Signup__logo",
	"title": "Signup__title",
	"info": "Signup__info",
	"error": "Signup__error",
	"forgot": "Signup__forgot",
	"post-info": "Signup__post-info",
	"reset-link": "Signup__reset-link"
};
module.exports = exports;
